import { TargetPersonaWebVisits } from "@intentsify/types";
import { ColumnDef } from "@tanstack/react-table";
import { EmptyCell } from "components";
import { sortWithOtherLast } from "./utils";

export const columns: Array<ColumnDef<TargetPersonaWebVisits>> = [
  {
    header: "Persona Name",
    accessorKey: "personaName",
    sortingFn: (rowA, rowB) =>
      sortWithOtherLast(rowA.original.personaName, rowB.original.personaName),
  },
  {
    header: "Job Level",
    accessorKey: "jobLevel",
    cell: ({ row }) => {
      if (!row?.original?.jobLevel) {
        return <EmptyCell />;
      }

      return row?.original.jobLevel;
    },
  },
  {
    header: "Job Function",
    accessorKey: "jobFunction",
    cell: ({ row }) => {
      if (!row?.original?.jobFunction) {
        return <EmptyCell />;
      }

      return row?.original.jobFunction;
    },
  },
  {
    header: "Activity",
    accessorKey: "matchTerm",
  },

  {
    header: "Week",
    accessorKey: "score7",
  },
  {
    header: "30 days",
    accessorKey: "score30",
  },
  {
    header: "60 days",
    accessorKey: "score60",
  },
  {
    header: "Total ",
    accessorKey: "scoreTotal",
  },
];
